import { MODEL_NAMES } from '../constants/index';
import { buildContacts } from '../utils/messaging/conversation';
import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingConversation extends MessagingBase {
  @service intl;
  @service messaging;
  @service store;

  urlForCreateRecord() {
    const include = encodeURIComponent('users,last_message');
    return super.urlForCreateRecord(...arguments) + `?include=${include}`;
  }

  fetchAndValidateUsers(conversation) {
    const baseUrl = this.buildURL(MODEL_NAMES.CONTACT);
    return fetch(`${baseUrl}/batch-create`, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({
        data: buildContacts(conversation, this.messaging.currentProfile),
      }),
    });
  }
}
